import styled from "styled-components";

const Stepper = styled.div`
  display: flex;
  width: 100%;
  height: 3px;
`;

export { Stepper };
